import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/layout";

import Section from "../../components/organisms/section";
import Header from "../../components/organisms/header";
import Footer from "../../components/organisms/footer";
import FormApply from "../../components/organisms/form-apply";

import HeaderBrand from "../../components/molecules/header-brand";
import FooterBrand from "../../components/molecules/footer-brand";
import FooterNav from "../../components/molecules/footer-nav";
import FooterCopy from "../../components/molecules/footer-copy";
import NavBar from "../../components/molecules/navbar";
import HeaderTitle from "../../components/molecules/header-title";
import List from "../../components/molecules/list";
import ListItem from "../../components/molecules/list-item";
import ImageContainer from "../../components/molecules/image-container";
import HeaderSubfacet from "../../components/molecules/header-subfacet";
import ButtonApply from "../../components/molecules/button-apply";

import Seo from "../../components/atoms/seo";
import FormWrapper from "../../components/organisms/form-wrapper";
import Progress from "../../components/atoms/progress";
import Versus from "../../components/atoms/versus";

class DigitalMarketer extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <Seo
          title="Koen | Back-End Developer | Silhouette"
          media="https://www.blastic.com/design/img/background/koen-h.jpg"
          description="Blastic is looking for a back-end developer profile. The silhouette of one of our back-end developers reveals what the job includes and what you can expect."
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <ButtonApply getTarget={() => document.getElementsByTagName("form")[0]}>
          Meet <br />
          <br />
          Koen
        </ButtonApply>
        <Section className="pt-5 py-sm-5">
          <HeaderTitle title="Koen | Back-end Developer" />
          <div className="row">
            <div className="col-md-6 pb-6 order-2 order-md-1">
              <p>Tech changes! And with it, the systems we are working with.</p>
              <p>
                In the past years, I’ve seen our Content Management Systems and
                implementations grow. We’re writing more code, which makes
                projects more complex. Today, we need more and more
                architectures, taking the setup and maintenance of these systems
                to a whole new level.
              </p>
              <p>
                One of the ways to cope with these architectural growths is
                using containers, taking away the pain of maintaining virtual
                machines. On the other hand, introducing new challenges such as
                overhauling deployment pipelines and changing our local
                development ecosystem.
              </p>
              <p>
                This is exactly what I’d like to discuss with you. How would you
                tackle this challenge, together with me?
              </p>
            </div>
            <div className="ml-auto col-md-5 order-1 order-md-2">
              <ImageContainer
                fluid={this.props.data.frontEndDeveloper.childImageSharp.fluid}
                overlay="gradient"
                negateRight={true}
                negateBottom={true}
                aspectRatio="1x1-5"
              >
                <h3 className="h6">I'm looking for a colleague</h3>
                <HeaderSubfacet title="Role" value="Back-End Developer" />
                <HeaderSubfacet title="Experience" value="> 2 years" />
                <HeaderSubfacet
                  title="Location"
                  value="Edegem (Antwerp) or Ghent"
                />
                <HeaderSubfacet title="Language" value="NL / EN / C#" />
                <HeaderSubfacet
                  title="Pay"
                  value="45K – 60K yearly (includes: insurance, car & fuel card, ...)"
                />
              </ImageContainer>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-7 section-shifted-left-blue">
          <div className="row">
            <div className="col-lg-11 ml-auto">
              <div className="row">
                <div className="col-sm-6">
                  <h2 className="h4 mb-2">What drives me in my job</h2>
                  <List>
                    <ListItem>Positive feedback from customers</ListItem>
                    <ListItem>Clean, optimised code</ListItem>
                    <ListItem>Open communication & trust</ListItem>
                    <ListItem>Delivering a finished product</ListItem>
                  </List>
                </div>
                <div className="col-sm-6">
                  <h2 className="h4 mb-2 mt-sm-7">I'm turned off by</h2>
                  <List>
                    <ListItem>
                      Overconfidence and not listening to customers enough
                    </ListItem>
                    <ListItem>Failure of self-improvement</ListItem>
                    <ListItem>People without a sense of humor</ListItem>
                  </List>
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Section className="py-5 py-sm-6 section-white">
          <div className="row">
            <div className="col-12 col-md-4 mr-auto negate-top pb-5 pb-md-0">
              <h2 className="h4">Personality</h2>
              <Versus
                value={70}
                scale={100}
                title="Introvert"
                titleOpponent="Extravert"
              />
              <Versus
                value={60}
                scale={100}
                title="Organized"
                titleOpponent="Chaotic"
              />
              <Versus value={50} scale={100} title="Think" titleOpponent="Do" />
              <Versus
                value={80}
                scale={100}
                title="Reserved"
                titleOpponent="Assertive"
              />
              <Versus
                value={60}
                scale={100}
                title="No-nonsense"
                titleOpponent="Diplomatic"
              />
              <Versus
                value={70}
                scale={100}
                title="Creative"
                titleOpponent="Analytical"
              />
            </div>
            <div className="col-6 col-md-4 col-lg-3 ml-auto">
              <h2 className="h4">Skills</h2>
              <Progress value={80} scale={100} title="C#" />
              <Progress
                value={80}
                scale={100}
                title="Sitecore / Kentico / Umbraco"
              />
              <Progress value={70} scale={100} title="Azure" />
              <Progress value={60} scale={100} title="SQL" />
              <Progress
                value={50}
                scale={100}
                title="JavaScript / HTML / CSS"
              />
              <Progress value={30} scale={100} title="Headless CMS" />
              <Progress value={20} scale={100} title="Docker / Kubernetes" />
            </div>
            <div className="col-6 col-md-4 col-lg-3 mx-auto">
              <h2 className="h4">Motivators</h2>
              <Progress
                value={80}
                scale={100}
                title="Solution & Out-of-the box thinking"
              />
              <Progress
                value={70}
                scale={100}
                title="Feedback, positive & constructive"
              />
              <Progress
                value={90}
                scale={100}
                title="Great colleagues and teamwork"
              />
            </div>
          </div>
        </Section>
        <FormWrapper path="Back-End">
          <FormApply className="section-grey">
            <h2 className="form-title mb-4">Meet Koen</h2>
            <div className="row">
              <div className="col-md-6 mb-4 mr-auto">
                <p>
                  Interested in Koen’s job and his presentation? Great! We hope
                  you’ll reach out so we can craft your very own Back-End
                  development job with us. You’ll meet Koen first, we promise!
                </p>
              </div>
            </div>
          </FormApply>
        </FormWrapper>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    frontEndDeveloper: file(relativePath: { eq: "background/koen-h.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 600) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default DigitalMarketer;
